import React from 'react'

export default ({ src }) => <img src={src} style={{ width: '100%' }}/>
